/**
 * @generated SignedSource<<1f26d23f5c76bfaa353bf46d712e7d37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhaseItem_project$data = {
  readonly budget_method: any;
  readonly id: number;
  readonly is_template: boolean;
  readonly team_id: number | null | undefined;
  readonly " $fragmentType": "PhaseItem_project";
};
export type PhaseItem_project$key = {
  readonly " $data"?: PhaseItem_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhaseItem_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhaseItem_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget_method",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "team_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    }
  ],
  "type": "projects",
  "abstractKey": null
};

(node as any).hash = "9292caea9efadba93e245278dd8a33cc";

export default node;
